export enum NotificationEventType {
    ObjectAdded = 'ObjectAdded',
    ObjectUpdated = 'ObjectUpdated',
    ObjectDeleted = 'ObjectDeleted',
}

export enum BasicEventTypeEnum {
    ObjectAdded = 'added',
    ObjectUpdated = 'updated',
    ObjectDeleted = 'deleted',
}